import React, { useMemo } from 'react'
import "./AllSolution.css"
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import AllSolutionsHero from '../../components/pages/AllSolutions/AllSolutionsHero/AllSolutionsHero'
import ConstNeed from '../../components/pages/AllSolutions/ConstNeed/ConstNeed'
import AllProductsExplore from '../../components/pages/AllProducts/AllProductsExplore/AllProductsExplore'
import Downloads from '../../components/pages/AllSolutions/Downloads/Downloads'
import AllSolutionsRequestNewProject from '../../components/pages/AllSolutions/AllSolutionsRequestNewProject/AllSolutionsRequestNewProject'
import {
    findPageSection,
    unwrapSectionData,
} from '../../utils/aboutStartNewProjectSection'
import {
    usePageContentAliases,
    useProductsExploreSection,
} from '../../hooks/usePublicQueries'

const SOLUTIONS_PAGE_ALIASES = ["allsolutions", "all-solution", "allsolution", "solutions"];

const AllSolution = () => {
    const { i18n } = useTranslation()
    const { data: pageContent } = usePageContentAliases(SOLUTIONS_PAGE_ALIASES, i18n.language)
    const { data: exploreContent } = useProductsExploreSection(i18n.language)

    const heroSection = useMemo(
        () =>
            findPageSection(pageContent, "hero") ||
            findPageSection(pageContent, "allsolutionshero") ||
            findPageSection(pageContent, "allsolutions"),
        [pageContent]
    )

    return (
        <div className='allsolution'>
            <Navbar />
                <AllSolutionsHero content={unwrapSectionData(heroSection)} />

            <div id="allsolution-guide" className="allsolution-content-guide">
                <ConstNeed />
                <AllProductsExplore content={exploreContent} />
                <Downloads />
                <AllSolutionsRequestNewProject />
            </div>
            <Footer />
        </div>
    )
}

export default AllSolution
